import { get } from '../utils';
import { toast } from '../components'; // alert

/**
 * 购物车商品结算验证
 */
export default function verification(data, callback: any) {
    get('newproduct/carts/v1/validate', data).then((rd) => {
        if (rd.errCode == 200) {
            if (!rd.data.isCheck && rd.data.respCode === 13901) {
                callback(false, rd);
            } else if (!rd.data.isCheck) {
                // toast('结算商品存在库存不足或已下架，请在购物车内重新选择商品');
                toast(rd.data.errorMessage)
            } else {
                callback(true)
            }
        } else {
            // alert(rd.errDesc, ["知道了"])
            toast(rd.errDesc);
        }
    });
}


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/operates/verification.ts